//@flow
import {IconButton, makeStyles, TableCell} from '@material-ui/core';
import {Edit} from '@material-ui/icons';
import React from 'react';
import {useState} from 'react';
import CustomModal from '../../../../../../elements/CustomModal/CustomModal';
import CustomTextField from '../../../../../../elements/CustomTextField/CustomTextField';
import {useResetSpecifications} from '../../../../../products/utils/hooks';
import {useProductContext} from '../../../../context';

import ProductFeatureModal from './ProductFeatureModal';

const useStyles = makeStyles(theme => ({
  textField: {
    width: '240px',

    '& input': {
      cursor: 'pointer',
    },
  },
}));

export default function ProductFeatureCell() {
  const classes = useStyles();

  const [specifications] = useProductContext(product => product.specifications);
  const [modalOpen, setModalOpen] = useState(false);

  const resetSpecifications = useResetSpecifications();

  const [newSpecifications, setNewSpecifications] = useState(specifications);

  const openDescriptionModal = () => setModalOpen(true);
  const closeDescriptionModal = () => {
    resetSpecifications();
    setModalOpen(false);
  };

  return (
    <>
      <TableCell component="th" scope="row">
        <CustomTextField
          name="features"
          className={classes.textField}
          value={newSpecifications}
          type="text"
          onFocus={() => {
            window.document.activeElement.blur();
            openDescriptionModal();
          }}
          InputProps={{
            endAdornment: (
              <IconButton edge="end" onClick={openDescriptionModal}>
                <Edit fontSize="small" />
              </IconButton>
            ),
          }}
        />
      </TableCell>
      <CustomModal open={modalOpen} handleCloseModal={closeDescriptionModal}>
        {modalOpen && (
          <ProductFeatureModal
            onSubmit={featuredProducts => {
              setNewSpecifications(featuredProducts);
              closeDescriptionModal();
            }}
          />
        )}
      </CustomModal>
    </>
  );
}
